import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Media Type Chip',
    description: 'A media type chip component',
    inputs: [
        {
            name: 'title',
            type: 'string',
            defaultValue: 'Premiere Pro Templates',
            helperText: 'The main title displayed on the chip',
        },
        {
            name: 'imageUrl',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            defaultValue: '',
            helperText: 'Square format image (recommended size: 48x48px or larger)',
        },
        {
            name: 'imageAlt',
            type: 'string',
            defaultValue: 'Media type icon',
            helperText: 'Alt text for the image (for accessibility)',
        },
        {
            name: 'showAssetCount',
            type: 'boolean',
            defaultValue: true,
            helperText: 'Toggle to show or hide the asset count',
        },
        {
            name: 'assetCount',
            type: 'string',
            defaultValue: '60,690 results',
            helperText: 'Number of assets or results (e.g., "60,690 results")',
            showIf: 'options.get("showAssetCount") === true',
        },
        {
            name: 'link',
            type: 'string',
            defaultValue: '',
            helperText: 'Optional URL to make the chip clickable (internal or external)',
        },
    ],
};
